<template>
  <div class="vx-card assigned-vessel-list">
    <div class="vx-card-header">
      <div class="alert-area">
        <div class="alert-title">船舶アラート</div>
        <crew-assignment-alert-card
          class="alert-card"
          :title="`入替船員未登録`"
          :unit-text="`隻`"
          :alert-data="manningVesselAlert"
          :alert-setting="manningVesselAlertSetting"
          :isVesselAlert="true"
        />
        <div class="alert-title">船員アラート</div>
        <crew-assignment-alert-card
          class="alert-card"
          :title="`下船準備`"
          :unit-text="`人`"
          :alert-data="disembarkationStandbyAlert"
          :alert-setting="disembarkationStandbyAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          class="alert-card"
          :title="`乗船準備`"
          :unit-text="`人`"
          :alert-data="embarkationStandbyAlert"
          :alert-setting="embarkationStandbyAlertSetting"
          :isVesselAlert="false"
        />
        <crew-assignment-alert-card
          class="alert-card"
          :title="`休暇希望重複`"
          :unit-text="`人`"
          :alert-data="dayOffRequestDuplicatedAlert"
          :alert-setting="dayOffRequestDuplicatedAlertSetting"
          :isVesselAlert="false"
        />
      </div>
    </div>
    <div class="vx-card-body">
      <div class="vessel-cards">
        <vessel-card
          v-for="vessel in vessels"
          :key="vessel.id"
          :vessel="vessel"
          :crews="crewsWithAlert"
          :crews-roles="crewsRoles"
          :vessel-alert="getVesselAlert(vessel)"
        />
      </div>
      <div class="empty-message" v-if="isEmptyVessels">
        船舶が登録されていません。
      </div>
    </div>
    <side-drawer :title="'下船中船員'">
      <div v-for="crew in ashoreCrews" :key="crew.id">
        <ashore-crew-card
          class="crew-card"
          :crew="crew"
          :role="getRole(crew)"
          :hasError="false"
          :hasWarning="false"
        />
      </div>
    </side-drawer>
  </div>
</template>

<script>
import CrewAssignmentAlertCard from "./CrewAssignmentAlertCard.vue";
import SideDrawer from "./SideDrawer.vue";
import VesselCard from "./VesselCard.vue";
import AshoreCrewCard from "./AshoreCrewCard.vue";

export default {
  name: "AssignedVesselList",
  components: {
    VesselCard,
    CrewAssignmentAlertCard,
    SideDrawer,
    AshoreCrewCard,
  },
  props: {
    vessels: {
      type: Array,
      required: true,
    },
    onboardingCrews: {
      type: Array,
      required: true,
    },
    ashoreCrews: {
      type: Array,
      required: true,
    },
    crewsRoles: {
      type: Array,
      required: true,
    },
    vesselAlerts: {
      type: Array,
      required: true,
    },
    crewAlerts: {
      type: Array,
      required: true,
    },
    crewAlertSettings: {
      type: Array,
      required: true,
    },
  },
  computed: {
    manningVesselAlert() {
      return (
        this.vesselAlerts.find(
          alert => alert.alert_kind === "REPLACEMENT_CREW_NOT_ASSIGNED"
        ) || {}
      );
    },
    embarkationStandbyAlert() {
      return (
        this.crewAlerts.find(
          alert => alert.alert_kind === "EMBARKATION_STANDBY"
        ) || {}
      );
    },
    disembarkationStandbyAlert() {
      return (
        this.crewAlerts.find(
          alert => alert.alert_kind === "DISEMBARKATION_STANDBY"
        ) || {}
      );
    },
    dayOffRequestDuplicatedAlert() {
      return (
        this.crewAlerts.find(
          alert => alert.alert_kind === "DAY_OFF_REQUEST_DUPLICATED"
        ) || {}
      );
    },
    crewsWithAlert() {
      return this.onboardingCrews.map(crew => {
        const matchingAlerts = this.crewAlerts.flatMap(alert =>
          alert.crews
            .filter(c => c.crew_info.id === crew.crew.id)
            .map(c => ({
              ...c.alert_info[0], // alert_info を展開
              alert_kind: alert.alert_kind,
            }))
        );

        return {
          ...crew,
          alerts: matchingAlerts,
        };
      });
    },
    manningVesselAlertSetting() {
      return this.crewAlertSettings.find(
        setting => setting.kind === "REPLACEMENT_CREW_NOT_ASSIGNED"
      );
    },
    embarkationStandbyAlertSetting() {
      return this.crewAlertSettings.find(
        setting => setting.kind === "EMBARKATION_STANDBY"
      );
    },
    disembarkationStandbyAlertSetting() {
      return this.crewAlertSettings.find(
        setting => setting.kind === "DISEMBARKATION_STANDBY"
      );
    },
    dayOffRequestDuplicatedAlertSetting() {
      return this.crewAlertSettings.find(
        setting => setting.kind === "DAY_OFF_REQUEST_DUPLICATED"
      );
    },
    isEmptyVessels() {
      return this.vessels.length === 0;
    },
  },
  methods: {
    getRole(crew) {
      const targetRole = crew.crew.crew_available_roles.find(
        role => role.is_appointed
      );
      if (!targetRole) return "";
      return this.crewsRoles.find(
        role => role.id === targetRole.enterprise_crew_role_id
      ).name;
    },
    getVesselAlert(vessel) {
      if (!this.vesselAlerts || this.vesselAlerts.length === 0) return {};
      return (
        this.vesselAlerts[0].vessels.find(
          v => v.vessel_info.id === vessel.id
        ) || {}
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.assigned-vessel-list {
  position: relative;
  height: 100%;
  overflow: auto;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-right: 35px;
}
.vx-card-header {
  .alert-title {
    font-size: 14px;
    font-weight: 600;
    color: #626262;
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
  .alert-area {
    height: 60px;
    margin-left: 30px;
    display: flex;
    .alert-card {
      margin-right: 12px;
    }
  }
}
.vx-card-body {
  width: 100%;
  height: calc(var(--vh, 1vh) * 100 - 270px);
  display: inline-block;
  margin-top: 16px;
  padding-left: 30px;
  padding-right: 10px;
  overflow: auto;
  .vessel-cards {
    width: max-content;
    display: flex;
    gap: 6px;
    align-items: flex-start;
  }
  .empty-message {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #626262;
  }
}

.crew-card {
  margin-top: 2px;
  color: #4f4f4f;
}
</style>
